import { useRef } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { setBackLayout } from "../../redux/slice/system";
import { useNavigate } from "react-router-dom";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";

export default function BackTopbar(props) {
  let { LayoutCss } = props;
  const system = useSelector((state) => state.system);
  const dispatch = useDispatch();
  const route_navigate = useNavigate();
  // 是否顯示 使用者資訊
  const overlay_user = useRef(null);

  return (
    <>
      <div className={`${LayoutCss["layout-topbar"]}`}>
        <Button
          className="p-button-main p-button-sm w-auto px-2 py-1"
          icon="pi pi-bars"
          onClick={() =>
            dispatch(
              setBackLayout({
                isShrink: !system.backLayout.isShrink,
                // isSideShow: !system.backLayout.isSideShow,
              })
            )
          }
        />
        <span
          className={classNames(
            "hidden md:inline-block",
            LayoutCss["layout-title"]
          )}
        >
          能源管理
        </span>

        {process.env.REACT_APP_MODE === "development" && (
          <div className="inline-block text-center text-xl text-white bg-red-500 font-bold px-2 py-0 ml-4">
            測試站
          </div>
        )}

        {/* <span className="flex-auto"></span>
        <span className="text-main hidden md:inline-block">
          使用者：{user.userDetail?.username}
        </span>
        <div className="relative">
          <Button
            className="p-button-main p-button-sm w-2rem p-1 ml-3"
            icon="pi pi-user"
            onClick={(e) => overlay_user.current.toggle(e)}
          />
        </div>
        <Button
          className="p-button-main p-button-sm w-auto px-3 py-1 ml-2"
          label="登出"
          onClick={() => logout()}
        /> */}
      </div>

      <OverlayPanel
        className="w-15rem mt-3 ml-5 p-0 shadow-1 overflow-y-auto"
        ref={overlay_user}
      >
        <div className="text-center bg-dark -m-1">
          <button
            type="button"
            className="w-full text-main text-lg font-bold bg-transparent hover:bg-dark-l cursor-pointer py-2 transition-all transition-duration-150 transition-ease-in-out border-none"
            onClick={(e) => {
              overlay_user.current.toggle(e);
              route_navigate("/back/password");
            }}
          >
            變更密碼
          </button>
        </div>
      </OverlayPanel>
    </>
  );
}

BackTopbar.propTypes = {
  LayoutCss: PropTypes.shape({
    "layout-title": PropTypes.string,
    "layout-topbar": PropTypes.string,
  }).isRequired,
};
